export const NEW_TASK_STEP=[
    "Application",
    "Dataset & Model",
    "Device Clustering",
    "Training Settings"
]